import { hygraphClient } from '@/lib/graphql-clients';
import { Discipline, getSdk } from '@/lib/types';

import NomadApiClient from '@/pages/api/api-clients/nomad-api';
import { transformGetDisciplinesResponse } from '@/services/transformers/disciplines-transformers';

export type { Discipline };

export type ApiDiscipline = {
  name: string;
  slug: string;
};

const get = async () => {
  const sdk = getSdk(hygraphClient());
  const { disciplines } = await sdk.Disciplines();

  return disciplines as Discipline[];
};

const getFromNomad = async () => {
  const { data } = await NomadApiClient.get<ApiDiscipline[]>(
    'v1/discipline-names',
    {
      params: {
        enabledOnly: true,
      },
      transformResponse: transformGetDisciplinesResponse,
    }
  );

  return data;
};

const DisciplinesService = {
  get,
  getFromNomad,
};

export default DisciplinesService;
